module.exports = __webpack_public_path__ + "static/media/popup_desk.3b034fe9.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/promotions/popup_desk.png
// module id = 250
// module chunks = 0